import { render, staticRenderFns } from "./FooterReviews.vue?vue&type=template&id=827a0388&scoped=true&"
import script from "./FooterReviews.vue?vue&type=script&lang=ts&"
export * from "./FooterReviews.vue?vue&type=script&lang=ts&"
import style0 from "./FooterReviews.vue?vue&type=style&index=0&id=827a0388&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827a0388",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsImageOrFallback: require('/var/www/packages/theme/components/atoms/ImageOrFallback.vue').default,AtomsMarkdownRender: require('/var/www/packages/theme/components/atoms/MarkdownRender.vue').default})
